document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
    const messages = [...bar.querySelectorAll('[data-announcement-message]')];
    const previous = bar.querySelector('[data-announcement-previous]');
    const next = bar.querySelector('[data-announcement-next]');
    if (messages.length < 2) return;
    let activeIndex = 0;
    let timer;
    const show = (index) => {
      activeIndex = (index + messages.length) % messages.length;
      messages.forEach((message, messageIndex) => {
        const active = messageIndex === activeIndex;
        message.classList.toggle('is-active', active);
        message.hidden = !active;
      });
    };
    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => show(activeIndex + 1), 6000);
    };
    previous?.addEventListener('click', () => { show(activeIndex - 1); restart(); });
    next?.addEventListener('click', () => { show(activeIndex + 1); restart(); });
    bar.addEventListener('mouseenter', () => window.clearInterval(timer));
    bar.addEventListener('mouseleave', restart);
    bar.addEventListener('focusin', () => window.clearInterval(timer));
    bar.addEventListener('focusout', restart);
    show(0);
    restart();
  });

  const toggle = document.querySelector('.mobile-menu-toggle');
  const menu = document.querySelector('#MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('.product-form').forEach((form) => {
    const wrapper = form.closest('.product-info');
    const select = form.querySelector('.variant-select');
    const hiddenVariant = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('.quantity-input');
    const minusButton = form.querySelector('[data-quantity-minus]');
    const plusButton = form.querySelector('[data-quantity-plus]');
    const pricePanel = form.querySelector('.product-price-panel');
    const currentPrice = form.querySelector('.product-price-current');
    const originalPrice = form.querySelector('.product-price-original');
    const discountBadge = form.querySelector('.product-discount-badge');
    const breakdown = form.querySelector('.product-price-breakdown');
    const addButton = form.querySelector('.add-to-cart');
    const buyNowButton = form.querySelector('[data-buy-now]');
    const buyNowStatus = form.querySelector('.buy-now-status');
    const gallery = wrapper?.closest('.product-grid')?.querySelector('.product-gallery');
    const pricingScript = form.querySelector('.product-pricing-data');
    let variants = [];
    const livePricingCache = new Map();
    const livePricingPromises = new Map();
    let livePricingTimer;
    let livePricingRequest = 0;

    try {
      variants = JSON.parse(pricingScript?.textContent || '[]');
    } catch (error) {
      console.warn('LOAM pricing data could not be read.', error);
    }

    const locale = pricePanel?.dataset.locale || document.documentElement.lang || 'en-US';
    const currency = pricePanel?.dataset.currency || 'USD';
    const money = new Intl.NumberFormat(locale, { style: 'currency', currency });
    const formatMoney = (cents) => money.format((Number(cents) || 0) / 100);
    const selectedVariantId = () => String(select?.value || hiddenVariant?.value || '');
    const selectedVariant = () => variants.find((variant) => String(variant.id) === selectedVariantId()) || variants[0];
    const pricingKey = (variant, quantity) => `${variant.id}:${quantity}:${window.Shopify?.country || ''}`;
    const amountToCents = (amount) => Math.round((Number(amount) || 0) * 100);

    const normalizeQuantity = (variant, requested) => {
      const minimum = Number(variant?.quantityRule?.min) || 1;
      const increment = Number(variant?.quantityRule?.increment) || 1;
      const maximum = variant?.quantityRule?.max == null ? null : Number(variant.quantityRule.max);
      let value = Math.max(minimum, Math.floor(Number(requested) || minimum));
      value = minimum + Math.round((value - minimum) / increment) * increment;
      if (maximum != null) value = Math.min(value, maximum);
      return value;
    };

    const unitPriceForQuantity = (variant, quantity) => {
      let unitPrice = Number(variant?.price) || 0;
      [...(variant?.breaks || [])]
        .sort((a, b) => Number(a.minimum) - Number(b.minimum))
        .forEach((priceBreak) => {
          if (quantity >= Number(priceBreak.minimum)) unitPrice = Number(priceBreak.price);
        });
      return unitPrice;
    };

    const applyQuantityRule = (variant) => {
      if (!quantityInput || !variant) return;
      const rule = variant.quantityRule || {};
      quantityInput.min = String(Number(rule.min) || 1);
      quantityInput.step = String(Number(rule.increment) || 1);
      if (rule.max == null) quantityInput.removeAttribute('max');
      else quantityInput.max = String(rule.max);
      quantityInput.value = String(normalizeQuantity(variant, quantityInput.value));
    };

    const renderPrice = (variant, quantity, livePricing = null) => {
      const pricingUnit = unitPriceForQuantity(variant, quantity);
      const baseTotal = pricingUnit * quantity;
      const total = livePricing?.totalCents ?? baseTotal;
      const regularUnitPrice = Math.max(Number(variant.compareAt) || 0, Number(variant.price) || 0);
      const regularTotal = regularUnitPrice * quantity;
      const savings = Math.max(0, regularTotal - total);
      const percent = regularTotal > 0 ? Math.round((savings / regularTotal) * 100) : 0;

      if (currentPrice) currentPrice.textContent = formatMoney(total);
      if (originalPrice) {
        originalPrice.hidden = savings <= 0;
        originalPrice.textContent = savings > 0 ? formatMoney(regularTotal) : '';
      }
      if (discountBadge) {
        discountBadge.hidden = savings <= 0;
        discountBadge.textContent = savings > 0 ? `Save ${formatMoney(savings)} (${percent}% off)` : '';
      }
      if (breakdown) {
        const itemText = `${quantity} ${quantity === 1 ? 'item' : 'items'} × ${formatMoney(pricingUnit)} each`;
        breakdown.textContent = livePricing?.automaticPercent > 0
          ? `${itemText} · ${livePricing.automaticPercent}% automatic discount applied`
          : itemText;
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? `Add ${quantity} to cart — ${formatMoney(total)}` : 'Sold out';
      }
      if (buyNowButton) {
        buyNowButton.disabled = !variant.available;
        buyNowButton.textContent = variant.available ? `Buy now — ${formatMoney(total)}` : 'Sold out';
      }
      if (minusButton) minusButton.disabled = quantity <= (Number(variant.quantityRule?.min) || 1);
      if (plusButton) plusButton.disabled = variant.quantityRule?.max != null && quantity >= Number(variant.quantityRule.max);
    };

    const fetchLivePricing = async (variant, quantity) => {
      const key = pricingKey(variant, quantity);
      if (livePricingCache.has(key)) return livePricingCache.get(key);
      if (livePricingPromises.has(key)) return livePricingPromises.get(key);

      const request = (async () => {
        const query = `mutation PreviewProductPrice($input: CartInput!) {
          cartCreate(input: $input) {
            cart {
              checkoutUrl
              cost { totalAmount { amount currencyCode } }
              lines(first: 1) {
                nodes {
                  cost { subtotalAmount { amount currencyCode } totalAmount { amount currencyCode } }
                  discountAllocations {
                    discountedAmount { amount currencyCode }
                    ... on CartAutomaticDiscountAllocation { title }
                  }
                }
              }
            }
            userErrors { field message }
          }
        }`;
        const buyerIdentity = window.Shopify?.country ? { countryCode: window.Shopify.country } : undefined;
        const response = await fetch('/api/2026-07/graphql.json', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query,
            variables: { input: { lines: [{ merchandiseId: `gid://shopify/ProductVariant/${variant.id}`, quantity }], buyerIdentity } },
          }),
        });
        const payload = await response.json();
        const result = payload?.data?.cartCreate;
        if (!response.ok || payload.errors?.length || result?.userErrors?.length || !result?.cart) {
          throw new Error(result?.userErrors?.[0]?.message || payload.errors?.[0]?.message || 'Live pricing is unavailable.');
        }
        const line = result.cart.lines.nodes[0];
        const subtotalCents = amountToCents(line?.cost?.subtotalAmount?.amount);
        const totalCents = amountToCents(result.cart.cost.totalAmount.amount);
        const automaticSavingsCents = (line?.discountAllocations || []).reduce(
          (sum, allocation) => sum + amountToCents(allocation.discountedAmount?.amount),
          0,
        );
        const preview = {
          key,
          totalCents,
          checkoutUrl: result.cart.checkoutUrl,
          automaticPercent: subtotalCents > 0 ? Math.round((automaticSavingsCents / subtotalCents) * 100) : 0,
        };
        livePricingCache.set(key, preview);
        return preview;
      })().finally(() => livePricingPromises.delete(key));

      livePricingPromises.set(key, request);
      return request;
    };

    const scheduleLivePricing = (variant, quantity) => {
      window.clearTimeout(livePricingTimer);
      const requestNumber = ++livePricingRequest;
      const key = pricingKey(variant, quantity);
      const cached = livePricingCache.get(key);
      if (cached) {
        renderPrice(variant, quantity, cached);
        return;
      }
      if (pricePanel) pricePanel.setAttribute('aria-busy', 'true');
      livePricingTimer = window.setTimeout(async () => {
        try {
          const preview = await fetchLivePricing(variant, quantity);
          const activeVariant = selectedVariant();
          const activeQuantity = activeVariant && quantityInput ? normalizeQuantity(activeVariant, quantityInput.value) : 0;
          if (requestNumber === livePricingRequest && String(activeVariant?.id) === String(variant.id) && activeQuantity === quantity && preview) {
            renderPrice(variant, quantity, preview);
          }
        } catch (error) {
          console.warn('LOAM live discount pricing could not be refreshed.', error);
        } finally {
          if (requestNumber === livePricingRequest && pricePanel) pricePanel.removeAttribute('aria-busy');
        }
      }, 180);
    };

    const updatePrice = () => {
      const variant = selectedVariant();
      if (!variant || !quantityInput) return;
      const quantity = normalizeQuantity(variant, quantityInput.value);
      quantityInput.value = String(quantity);
      const cached = livePricingCache.get(pricingKey(variant, quantity));
      renderPrice(variant, quantity, cached);
      scheduleLivePricing(variant, quantity);
    };

    const updateVariant = () => {
      const variant = selectedVariant();
      if (!variant) return;
      applyQuantityRule(variant);
      updatePrice();

      const option = select?.options[select.selectedIndex];
      if (gallery && option?.dataset.mediaId) {
        const activeMedia = gallery.querySelector(`[data-media-id="${option.dataset.mediaId}"]`);
        gallery.querySelectorAll('.product-gallery-item').forEach((item) => item.classList.remove('is-variant-active'));
        if (activeMedia) {
          activeMedia.classList.add('is-variant-active');
          if (gallery.firstElementChild !== activeMedia) gallery.prepend(activeMedia);
          if (window.matchMedia('(max-width: 520px)').matches) gallery.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    };

    select?.addEventListener('change', updateVariant);
    wrapper?.querySelectorAll('.format-card input').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!select) return;
        select.value = radio.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        wrapper.querySelectorAll('.format-card').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.format-card')?.classList.add('is-selected');
      });
    });

    quantityInput?.addEventListener('input', updatePrice);
    quantityInput?.addEventListener('change', updatePrice);
    minusButton?.addEventListener('click', () => {
      const variant = selectedVariant();
      const increment = Number(variant?.quantityRule?.increment) || 1;
      quantityInput.value = String(normalizeQuantity(variant, Number(quantityInput.value) - increment));
      updatePrice();
    });
    plusButton?.addEventListener('click', () => {
      const variant = selectedVariant();
      const increment = Number(variant?.quantityRule?.increment) || 1;
      quantityInput.value = String(normalizeQuantity(variant, Number(quantityInput.value) + increment));
      updatePrice();
    });

    buyNowButton?.addEventListener('click', async () => {
      const variant = selectedVariant();
      if (!variant?.available || !quantityInput || buyNowButton.disabled) return;
      const quantity = normalizeQuantity(variant, quantityInput.value);
      quantityInput.value = String(quantity);
      buyNowButton.disabled = true;
      if (addButton) addButton.disabled = true;
      buyNowButton.textContent = 'Preparing checkout…';
      if (buyNowStatus) buyNowStatus.textContent = '';

      try {
        const preview = await fetchLivePricing(variant, quantity);
        if (preview?.checkoutUrl) {
          window.location.assign(preview.checkoutUrl);
          return;
        }
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant.id), quantity }] }),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'This item could not be added.');
        }
        window.location.assign('/checkout');
      } catch (error) {
        if (buyNowStatus) buyNowStatus.textContent = error.message || 'Checkout could not be opened. Please try again.';
        updatePrice();
      }
    });

    updateVariant();
  });

  document.querySelectorAll('[data-cart-quantity-control]').forEach((control) => {
    const input = control.querySelector('[data-cart-quantity-input]');
    const minus = control.querySelector('[data-cart-quantity-minus]');
    const plus = control.querySelector('[data-cart-quantity-plus]');
    if (!input) return;
    const normalize = (value) => Math.max(0, Math.floor(Number(value) || 0));
    minus?.addEventListener('click', () => { input.value = String(normalize(input.value) - 1 < 0 ? 0 : normalize(input.value) - 1); });
    plus?.addEventListener('click', () => { input.value = String(normalize(input.value) + 1); });
  });
});
